"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShortCut = void 0;
var react_1 = require("react");
function useShortCut(props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, shortCut = props.shortCut, handler = props.handler;
    (0, react_1.useEffect)(function () {
        if (disabled) {
            return;
        }
        var handleKeyDown = function (event) {
            if ((event.key && event.key.toLowerCase() === shortCut.toLowerCase()) ||
                (shortCut === "BracketLeft" && event.key === "[") ||
                (shortCut === "BracketRight" && event.key === "]")) {
                event.preventDefault();
                handler();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handler, shortCut, disabled]);
}
exports.useShortCut = useShortCut;
//# sourceMappingURL=shortcut.js.map